<template>
  <div class="service-box content-1200">
    <div class="text-center font-blod color-level1 margin-b20 fontSize36">联盟服务</div>
    <div class="text-center color-level2 fontWeight-500 fontSize18 margin-b60">
      专业服务支撑，加速应用生产，助力生态共赢
    </div>
    <div class="service flex-nowrap">
      <div class="service-item radius-8" v-for="(item,index) in services" :key="index">
        <div class="service-item-img">
          <img :src="item.pic" alt="">
        </div>
        <div class="service-item-detail flex-column">
          <div class="color-level1 font-blod margin-b20 fontSize20">{{ item.title }}</div>
          <div class="desc color-level2 fontWeight-500">{{ item.desc }}</div>
          <more-button text="了解更多" @handleClick="$router.push(item.link)"></more-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import MoreButton from "@/components/common/MoreButton";

export default {
  components: {MoreButton},
  data() {
    return {
      services: [
        {
          pic: require('@/assets/img/home/service-authentication.png'),
          title: '金标认证',
          desc: '金标认证服务旨在甄选出在稳定性、兼容性、性能、功耗、安全、隐私等方面均达到行业领先水平的应用，并在小米、OPPO、vivo、荣耀等品牌的应用市场中向用户推介。提升应用服务品质，提高用户信任感与认同感。',
          link: '/home/union/service'
        },
        {
          pic: require('@/assets/img/home/service-openness.png'),
          title: '开放能力',
          desc: '为了让开发者可以使用更多的系统能力，并降低接入成本，我们制定了联盟开放能力的统一标准。',
          link: '/home/union/openness'
        }
      ]
    }
  }
}
</script>
<style scoped lang="scss">
.service-box {
  padding: 80px 0 40px;

  .service {
    &-item {
      background: #fff;
      flex: 1;
      &:hover img{
        transform: scale(1.2);
      }

      &-img {
        width: 100%;
        // height: 320px;
        overflow: hidden;

        img {
          width: 100%;
          // height: 100%;
          transition: all .5s ease-out;
        }
      }

      &-detail {
        padding: 40px 32px;
        height: calc(100% - 320px);

        .desc {
          margin-bottom: 32px;
          line-height: 24px;
          flex: 1;
        }

        /deep/ .more-btn {
          margin: inherit;
        }
      }

      &:first-of-type {
        margin-right: 20px;
      }
    }

  }
}

@media screen and (max-width: 767px) {
  .service {
      .service-item{
        width:45%;
        margin-right: 0;
      }
  }
}
</style>
